import { WalkAndPunchApiClient } from 'src/proxy/api/walkandpunch-api.proxy';
import { Injectable } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';
import { LoginService } from 'src/app/core/services/login.service';

import { StoreModel } from '../models/model.store';

@Injectable()
export class LocationProjectStoreService {
  _locationProjects$ = new BehaviorSubject<StoreModel>(null);

  constructor(
    private locationProjectService: WalkAndPunchApiClient,
    private loginService: LoginService
  ) {}

  reloadLocationProjects() {
    const projectTemplate = this.loginService.projectTemplate;
    this.loadLocationProjects()
      .pipe(take(1))
      .subscribe((data) => {
        this.locationProjects = {
          data,
          projectId: projectTemplate.project.id,
          templateId: projectTemplate.template.id,
        };
      });
  }

  loadLocationProjects() {
    return this.locationProjectService.v1LocationProjectGetAllByProjectGET();
  }

  get locationProjects() {
    return this._locationProjects$.value;
  }

  set locationProjects(data: StoreModel) {
    this._locationProjects$.next(data);
  }

  get locationProjects$() {
    return this._locationProjects$;
  }
}
